<script setup lang="ts">
import { useRoute } from 'vue-router'
import MobileNavigation from './components/MobileNavigation.vue'
import MainNavigation from './components/MainNavigation.vue'
import { isMobileView } from './utils/global'
import { computed, onBeforeMount } from 'vue'
import { checkLoginAndHandleSplashScreen } from './utils/splashScreen'
import AlertComponent from '@/components/common/AlertComponent.vue'
import DialogComponent from '@/components/common/DialogComponent.vue'

const route = useRoute()
const isRegisterView = computed(() => route.name === 'register')

onBeforeMount(async () => {
  try {
    await checkLoginAndHandleSplashScreen()
  } catch (err) {
    console.error('Error during onBeforeMount:', err)
    setTimeout(() => {
      window.location.reload()
    }, 2000)
  }
})
</script>

<template>
  <header v-if="!isRegisterView">
    <div class="centered" v-if="isMobileView()">
      <tag-access-logo height="80px" name></tag-access-logo>
    </div>
    <div class="centered" v-if="!isMobileView()">
      <MainNavigation />
    </div>
  </header>
  <RouterView />
  <v-layout>
    <v-footer v-if="isMobileView()">
      <MobileNavigation v-if="isMobileView()" />
    </v-footer>
  </v-layout>
  <AlertComponent />
  <DialogComponent />
</template>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    /* display: flex; */
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    /* display: flex;
    place-items: flex-start;
    flex-wrap: wrap; */
  }

  nav {
    text-align: left;
    font-size: 1rem;
    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
